export default function NoiseOverlay() {
  return <div className="grain-overlay" aria-hidden="true" />;
}
